export class Folk{
    id : number;
    folkCode : string;
    folkName : string; 
    folkYear : number;
    isNote: boolean;
} 